export const EVENT_MODULES = {
  featuredEvents: 'featured-events',
  similarEvents: 'similar-events',
  allEvents: 'all-events',
  pastEvents: 'past-events',
  userPerksDetails: 'user-perks-details'
}

export const EVENT_TYPES = {
  events: 'event',
  screenings: 'screenings',
  fitness: 'fitness',
  promotions: 'promotions',
  cart: 'cart',
  contentPerks: 'content-perks',
  visits: 'visits'
}

export const ITEM_NAMES = {
  PERK_COUPON: 'perk-coupon',
  PERK_WEBSITE: 'perk-website'
}

export const ITEM_TYPES = {
  CONTENT_PERKS: 'content-perks'
}

export const ERROR_TYPES = { 
  NO_SEARCH_RESULTS: 'no-search-results', 
  PAYMENT: 'payment', 
  PLATFORM: 'platform', 
}

export const CATEGORY_NAMES = {
  ROOMS: 'Rooms'
}

export const FORM = {
  NEWSLETTER: 'newsletter',
  ENQUIRY: 'enquiry',
  PERSONAL_PHOTO_UPLOAD: 'personal-photo-upload',
  ID_UPLOAD: 'valid-id-photo-upload'
}

export const EVENT = {
  FORM_LOAD: 'form.load.auto.dataLayer.load',
  FORM_SUCCESS: 'form.interact.auto.success.formSuccess',
  FORM_ERROR: 'form.interact.auto.error.formError',
  MODULE_LOAD: 'module.load.auto.dataLayer.load',
  PROMOTION_LOAD: 'promotion.load.auto.dataLayer.load',
  CART_LOAD: 'cart.load.auto.dataLayer.load',
  FILTER_APPLY: 'filter.interact.manual.click.apply',
  FILTER_CLEAR: 'filter.interact.manual.click.clear',
  REGISTRATION_SUCCESS: 'user.interact.auto.success.registrationSuccess',
  GUEST_INVITATION_CONFIRM: 'user.interact.auto.success.guestInvitationConfirm',
  GUEST_INVITATION_REJECT: 'user.interact.auto.success.guestInvitationReject',
  PHOTO_UPLOAD: 'form.interact.auto.success.photoUpload',
  PRODUCT_LOAD: 'product.load.auto.dataLayer.load',
  PRODUCT_CLICK: 'product.internal.manual.click',
  PRODUCT_ADD_TO_CART: 'product.interact.manual.click.addToCart', 
  SEARCH: 'search.interact.manual.search',
  SEARCH_ERROR: 'search.interact.manual.search.error', 
  TRANSACTION_LOAD: 'transaction.load.auto.success.transactionSuccess',
  TRANSACTION_CANCEL: 'transaction.load.auto.success.transactionCancel',
  TRANSACTION_ERROR: 'transaction.load.auto.error.transactionError'
}

export const SCREEN_ROUTES = {
  'home': [/index/],
  'general-info': [/about/, /terms-and-policies\/house-rules/, /discounts/, /careers/, /legal/, /accessibility/],
  'contact': [/contact/],
  'bedrooms': [/bedrooms/],
  'faq': [/faq/],
  'locations': [/locations/],
  'whats-on': [/whats-on/],
  'houses': [/houses/],
  'restaurants': [/restaurants/],
  'event-spaces': [/event-spaces/],
  'membership-info': [/membership/],
  'membership-application': [/apply\/(.*)/],
  'projects': [/projects/],
  'account-signup': [/account\/(.*)/, /settings\/applications/],
  'profile-settings': [/settings\/(.*)/],
  'house-notes': [/house-notes/],
  'planner': [/my-planner/],
  'perks': [/perks/],
  'room-booking': [],
  'error': []
}

export const NAVIGATION_TYPE = {
  NAVIGATION_MENU: 'navigation-menu',
  NAVIGATION_DROPDOWN: 'navigation-dropdown'
}

export const ANALYTICS_MISC = {
  UNKNOWN_TYPE: 'unknown-type'
}
